module.exports = __webpack_public_path__ + "media/images/orni_quiz/login_howto-2bed9046ee6f45849c5d6f4fa49d1e69.png";